// src/app/pages/dashboard/components/statswidget.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { TranslateService } from '../../../services/translate.service';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { UploadedFilesDialogComponent } from '../statistics/uploaded-files-dialog.component';
import { UploadedFilesWidgetComponent } from '../statistics/uploaded-files-widget.component';
import { JournalMovesWidgetComponent } from '../statistics/journal-moves-widget.component';
import { UploadedJournalMovesDialogComponent } from '../statistics/journal-moves-dialog.component';
import { UploadedSuppliersWidgetComponent } from '../statistics/supplier-counter-widget.component';
import { UploadedSuppliersDialogComponent } from '../statistics/supplier-counter-dialog.component';


@Component({
  standalone: true,
  selector: 'app-stats-widget',
  imports: [CommonModule, UploadedFilesWidgetComponent,JournalMovesWidgetComponent,UploadedSuppliersWidgetComponent, DynamicDialogModule],
  templateUrl: './statswidget.html',
  providers: [DialogService]
})
export class StatsWidget {
  constructor(private dialogService: DialogService, public translateServ : TranslateService) {}

  openDialogUploads(caller?: string): void {
        this.dialogService.open(UploadedFilesDialogComponent, {
          header: this.translateServ.dictionary['STAT_TIT_UPDS'],
          width: '80vw',
          modal: true,
          dismissableMask: true,
          draggable: true, // allow moving the dialog
          closable: true, // Show close button in header
          maximizable: true, // Show maximize button in header
          data: { caller } // pass caller (optional)
        });
  }

  openDialogCreaded(caller?: string): void {
    this.dialogService.open(UploadedJournalMovesDialogComponent, {
      header: this.translateServ.dictionary['STAT_TIT_JRNS'],
      width: '80vw',
      modal: true,
      dismissableMask: true,
      draggable: true, 		   // allow moving the dialog
			closable: true,        // Show close button in header
  		maximizable: true,     // Show maximize button in header
      data: { caller } // pass caller (optional)
    });
  }

  openDialogSuppliers(caller?: string): void {
    this.dialogService.open(UploadedSuppliersDialogComponent, {
      header: this.translateServ.dictionary['STAT_TIT_SUPS'],
      width: '80vw',
      modal: true,
      dismissableMask: true,
      draggable: true, 		   // allow moving the dialog
			closable: true,        // Show close button in header
  		maximizable: true,     // Show maximize button in header
      data: { caller } // pass caller (optional)
    });
  }
}
